import api from './api';
export const projectService = {
    async inventory(page=1){return(await api.get('/inventory',{params:{page}})).data;},
    async inventoryProject(id){return(await api.get(`/inventory/projects/${id}`)).data;},
    async inventoryRoom(id){return(await api.get(`/inventory/rooms/${id}`)).data;},
    async lookup(code) { return (await api.get('/projects/lookup', { params: { code } })).data; },
  async saveImages(id, data) { return (await api.post(`/projects/${id}/images`, data)).data; },
  async deleteRooms(id, ids) { return (await api.post(`/projects/${id}/rooms/bulk-delete`, { ids })).data; },
  async roomImage(id, roomId, index) { const response = await api.get(`/projects/${id}/rooms/${roomId}/images/${index}`, { responseType: 'arraybuffer' }); return { data: response.data, type: response.headers['content-type'] }; },
  async updateRoom(id, roomId, data) { return (await api.post(`/projects/${id}/rooms/${roomId}`, data)).data; },
  async createRoom(id, data) { return (await api.post(`/projects/${id}/rooms`, data)).data; },
  async get(id) { return (await api.get(`/projects/${id}`)).data; },
  async list(page = 1) { return (await api.get('/projects', { params: { page } })).data; },
  async owners() { return (await api.get('/projects/owners')).data; },
  async save(data, id) { return (await (id ? api.put(`/projects/${id}`, data) : api.post('/projects', data))).data; },
};
export const workflowService = {
  async release(id) { return (await api.post(`/rooms/${id}/release`)).data; },
  async settings() { return (await api.get('/listing-settings')).data; },
  async configure(data) { return (await api.put('/listing-settings', data)).data; },
  async statistics() { return (await api.get('/dashboard-statistics')).data; },
  async commissions(page = 1, id) { return (await api.get('/commissions', { params: { page, id } })).data; },
  async commissionStatus(id, data) { return (await api.put(`/commissions/${id}`, data)).data; },
  async renew(id, data) { return (await api.post(`/rooms/${id}/renew`, data)).data; },
};
export const authService = {
  async register(data) {
    const response = await api.post('/register', data);
    return response.data;
  },

  async verifyRegistration(data) {
    const response = await api.post('/register/verify', data);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  async resendRegistrationCode(data) {
    const response = await api.post('/register/resend-code', data);
    return response.data;
  },

  async login(email, password) {
    const response = await api.post('/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  async logout() {
    try {
      await api.post('/logout');
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  async getMe() {
    const response = await api.get('/me');
    return response.data;
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  },

  isAdmin() {
    const user = this.getCurrentUser();
    return user?.role === 'admin';
  },

  isSaler() {
    const user = this.getCurrentUser();
    return user?.role === 'saler';
  },
};

export const roomService = {
  async getRooms(params = {}) {
    const response = await api.get('/rooms', { params });
    return response.data;
  },

  async getRoom(id, signal) {
    const response = await api.get(`/rooms/${id}`, { signal });
    return response.data;
  },

  async createRoom(data) {
    const response = await api.post('/rooms', data);
    return response.data;
  },

  async updateRoom(id, data) {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      data.append('_method', 'PUT');
      const response = await api.post(`/rooms/${id}`, data);
      return response.data;
    }

    const response = await api.put(`/rooms/${id}`, data);
    return response.data;
  },

  async deleteRoom(id) {
    const response = await api.delete(`/rooms/${id}`);
    return response.data;
  },

  async getMyRooms(params = {}) {
    const response = await api.get('/my-rooms', { params });
    return response.data;
  },
  async getAdminRooms(params = {}, signal) {
    const response = await api.get('/admin/rooms', { params, signal });
    return response.data;
  },
};

export const aiService = {
  async generateRoomDescription(data) {
    const response = await api.post('/ai/room-description', data);
    return response.data;
  },
};

export const bookingService = {
  async getBookings(params = {}) {
    const response = await api.get('/bookings', { params });
    return response.data;
  },

  async getBooking(id) {
    const response = await api.get(`/bookings/${id}`);
    return response.data;
  },

  async createBooking(data) {
    const response = await api.post('/bookings', data);
    return response.data;
  },

  async updateBooking(id, status) {
    const response = await api.put(`/bookings/${id}`, { status });
    return response.data;
  },

  async deleteBooking(id) {
    const response = await api.delete(`/bookings/${id}`);
    return response.data;
  },
};

export const depositFormService = {
  async startEditing(id) { return (await api.post(`/deposit-forms/${id}/edit-draft`)).data; },
  async getDrafts() { return (await api.get('/deposit-drafts')).data; },
  async getDraft(id) { return (await api.get(`/deposit-drafts/${id}`)).data; },
  async saveDraft(id, data) { return (await api.post(`/deposit-drafts/${id}`, data)).data; },
  async deleteDraft(id) { return (await api.delete(`/deposit-drafts/${id}`)).data; },
  async getDraftFile(id, kind) { return (await api.get(`/deposit-drafts/${id}/files/${kind}`, { responseType: 'blob' })).data; },
  async extractIdentity(data, signal) {
    const response = await api.post('/identity/extract', data, { signal, timeout: 65000 });
    return response.data.data;
  },

  async getDeposits(params) {
    const response = await api.get('/deposit-forms', {params});
    return response.data;
  },

  async createDeposit(data) {
    const response = await api.post('/deposit-forms', data);
    return response.data;
  },

  async updateDeposit(id, status) {
    const response = await api.put(`/deposit-forms/${id}`, { status });
    return response.data;
  },

  async deleteDeposit(id) {
    const response = await api.delete(`/deposit-forms/${id}`);
    return response.data;
  },
};

export const userService = {
  async getUsers() {
    const response = await api.get('/users');
    return response.data;
  },

  async getRoomPostersStatistics() {
    const response = await api.get('/admin/room-posters-statistics');
    return response.data;
  },

  async getUser(id) {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  async updateUser(id, data) {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  async deleteUser(id) {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
};

export const infoService = {
  async getDatabaseInfo() {
    const response = await api.get('/database-info');
    return response.data;
  },
};

export const walletService = {
  async pendingTopUps(page=1){return(await api.get('/wallet/top-ups/pending',{params:{page}})).data;},
  async confirmTopUp(id,data){return(await api.post(`/wallet/top-ups/${id}/confirm`,data)).data;},
  async requestTopUpReview(id){return(await api.post(`/wallet/top-ups/${id}/request-review`)).data;},
  async reviewTopUp(id,data){return(await api.post(`/wallet/top-ups/${id}/review`,data)).data;},
  async getTransactions(page=1) {
    const response = await api.get('/wallet/transactions',{params:{page}});
    return response.data;
  },

  async createTopUp(data) {
    const response = await api.post('/wallet/top-up', data);
    return response.data;
  },
};

export const ownerRegistrationRequestService = {
  async create(data) {
    const response = await api.post('/owner-registration-requests', data);
    return response.data;
  },

  async getMyLatest() {
    const response = await api.get('/owner-registration-requests/my-latest');
    return response.data;
  },

  async getAll(params = {}) {
    const response = await api.get('/owner-registration-requests', { params });
    return response.data;
  },

  async review(id, data) {
    const response = await api.put(`/owner-registration-requests/${id}/review`, data);
    return response.data;
  },

  async markRejectedNoticeSeen(id) {
    const response = await api.post(`/owner-registration-requests/${id}/seen-rejected-notice`);
    return response.data;
  },

  async markApprovedNoticeSeen(id) {
    const response = await api.post(`/owner-registration-requests/${id}/seen-approved-notice`);
    return response.data;
  },
};
